<div class="number-format-modal">
  <div class="modal-header">
    <h3>{{ 'builderScreen.inspector.numberFormatModal.title' | translateTA }}</h3>
    <p class="help-text">{{ 'builderScreen.inspector.numberFormatModal.description' | translateTA }}</p>
  </div>

  <form [formGroup]="form" class="modal-content">
    <!-- Preview em tempo real -->
    <div class="preview-section">
      <div class="preview-label">{{ 'builderScreen.inspector.numberFormatModal.preview' | translateTA }}</div>
      <div class="preview-value">{{ previewResult }}</div>
      <div class="preview-input-label">{{ 'builderScreen.inspector.numberFormatModal.previewValue' | translateTA }}: {{ previewValue }}</div>
    </div>

    <nz-divider></nz-divider>

    <!-- Configurações de formato -->
    <div class="format-settings">
      <!-- Casas Decimais -->
      <div class="setting-row">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">
            {{ 'builderScreen.inspector.numberFormatModal.decimalPlaces' | translateTA }}
          </nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input 
              nz-input 
              type="number" 
              formControlName="decimalPlaces"
              min="0"
              max="10"
              step="1"
              [style.width.%]="100" />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Separador de Milhar (checkbox) -->
      <div class="setting-row">
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <label nz-checkbox formControlName="formatThousands">
              {{ 'builderScreen.inspector.numberFormatModal.formatThousands' | translateTA }}
            </label>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Separadores (só aparece se formatThousands está ativo) -->
      <div class="separators-row" *ngIf="form.get('formatThousands')?.value">
        <div class="setting-item">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">
              {{ 'builderScreen.inspector.numberFormatModal.thousandSeparator' | translateTA }}
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select formControlName="thousandSeparator" [style.width.%]="100">
                <nz-option nzValue="." [nzLabel]="'builderScreen.inspector.separator.dot' | translateTA"></nz-option>
                <nz-option nzValue="," [nzLabel]="'builderScreen.inspector.separator.comma' | translateTA"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="setting-item">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">
              {{ 'builderScreen.inspector.numberFormatModal.decimalSeparator' | translateTA }}
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select formControlName="decimalSeparator" [style.width.%]="100">
                <nz-option nzValue="," [nzLabel]="'builderScreen.inspector.separator.comma' | translateTA"></nz-option>
                <nz-option nzValue="." [nzLabel]="'builderScreen.inspector.separator.dot' | translateTA"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Separador decimal (só quando formatThousands está desativado) -->
      <div class="setting-row" *ngIf="!form.get('formatThousands')?.value">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">
            {{ 'builderScreen.inspector.numberFormatModal.decimalSeparator' | translateTA }}
          </nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select formControlName="decimalSeparator" [style.width.%]="100">
              <nz-option nzValue="," [nzLabel]="'builderScreen.inspector.separator.comma' | translateTA"></nz-option>
              <nz-option nzValue="." [nzLabel]="'builderScreen.inspector.separator.dot' | translateTA"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <nz-divider></nz-divider>

      <!-- Prefixo e Sufixo -->
      <div class="addon-row">
        <div class="setting-item">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">
              {{ 'builderScreen.inspector.numberFormatModal.addonBefore' | translateTA }}
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input 
                nz-input 
                formControlName="addonBefore"
                [placeholder]="'Ex: R$, $, €'"
                nzSize="default" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="setting-item">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">
              {{ 'builderScreen.inspector.numberFormatModal.addonAfter' | translateTA }}
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input 
                nz-input 
                formControlName="addonAfter"
                [placeholder]="'Ex: %, kg, un'"
                nzSize="default" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
  </form>

  <div class="modal-footer">
    <button nz-button nzType="default" (click)="handleCancel()">
      {{ 'builderScreen.inspector.numberFormatModal.cancel' | translateTA }}
    </button>
    <button nz-button nzType="primary" (click)="handleOk()">
      {{ 'builderScreen.inspector.numberFormatModal.save' | translateTA }}
    </button>
  </div>
</div>
